export default __webpack_public_path__ + "static/media/quote.3c06c570.svg";